<template>
  <StorageActivity></StorageActivity>
</template>
<script>
import StorageActivity from '@/components/StorageActivity' 
export default {
  components:{
    StorageActivity,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
